// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".libraryContainer--Ae92wN7x {\n  height: 400px;\n  width: 830px;\n  display: grid;\n  grid-template-columns: 160px 1fr;\n}\n.wrapper--zGGjvHa0 {\n  position: relative;\n}\n.wrapper--zGGjvHa0 .closeBtn--39_t6TvW {\n    position: absolute;\n    right: 0;\n    top: 8px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"libraryContainer": "libraryContainer--Ae92wN7x",
	"wrapper": "wrapper--zGGjvHa0",
	"closeBtn": "closeBtn--39_t6TvW"
};
export default ___CSS_LOADER_EXPORT___;
